export default "__VITE_ASSET__UMVnvAW7__"